var _style, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAmericanExpress = function SvgAmericanExpress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "american-express_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 40 26",
    style: {
      enableBackground: "new 0 0 40 26"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".american-express_svg__st1,.american-express_svg__st2{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}.american-express_svg__st2{fill:#296bb4}")), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#296bb4"
    },
    d: "M0 0h40v26H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "american-express_svg__st1",
    d: "M18.442 24.448V12.332H40v3.342l-2.507 2.674L40 21.022v3.426h-3.927l-2.173-2.34-2.089 2.34z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "american-express_svg__st2",
    d: "M19.862 23.111v-9.443h8.022v2.173h-5.432v1.421H27.8v2.172h-5.348v1.421h5.432v2.256z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "american-express_svg__st2",
    d: "m27.884 23.111 4.428-4.763-4.428-4.68h3.426l2.674 2.925 2.757-2.925H40l-4.345 4.68L40 22.944v.167h-3.342L33.9 20.103l-2.674 3.008z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "american-express_svg__st1",
    d: "M19.444 1.552h5.181l1.838 4.095V1.552h6.434l1.087 3.092 1.17-3.092H40v12.116H14.096z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m20.447 2.889-4.178 9.442h2.841l.752-1.922h4.262l.752 1.922H27.8l-4.178-9.442h-3.175zm.334 5.432 1.253-3.008 1.253 3.008h-2.506zM27.884 12.332V2.889h4.094l2.089 5.766 2.089-5.766H40v9.443h-2.507V5.814l-2.339 6.518h-2.257l-2.423-6.518v6.518z",
    className: "american-express_svg__st2"
  })));
};
export default SvgAmericanExpress;